const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const handleResponse = async (response) => {
  if (!response.ok) {
    let message = 'Ocurrió un error en la solicitud.';
    try {
      const error = await response.json();
      message = error.message || message;
    } catch (_) {
      // sin cuerpo JSON
    }
    throw new Error(message);
  }
  return response.json();
};

const postJson = async (path, body) => {
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
  return handleResponse(response);
};

// Matriz de completitud de registros diarios de todos los centros activos.
// Omitir `to` evalúa un solo día.
export const fetchCompliance = ({ from, to } = {}) =>
  postJson('/monitoring/compliance', { from, to });

// Salud de métricas contra los parámetros de cada centro.
// Siempre agrega los registros crudos del período; { year, month } admite el
// mes en curso, { from, to } un rango libre.
export const fetchMetricsHealth = ({ year, month, from, to } = {}) =>
  postJson('/monitoring/metrics-health', { year, month, from, to });

// Lista de chequeo semanal de un centro. `weekStart` puede ser cualquier día
// de la semana: el backend lo normaliza al lunes.
export const fetchWeeklyChecklist = ({ laundryId, weekStart } = {}) =>
  postJson('/monitoring/weekly-checklist', { laundryId, weekStart });

// Cobertura de consolidados mensuales por centro para un año.
export const fetchCoverage = async (year) => {
  const qs = year ? `?year=${year}` : '';
  const response = await fetch(`${API_URL}/monitoring/coverage${qs}`);
  return handleResponse(response);
};

// Dispara el chequeo diario de digitación (por defecto, ayer). Idempotente.
export const runDailyCheck = (date) =>
  postJson('/monitoring/run-daily-check', { date });

// Dispara la evaluación mensual de métricas de un mes cerrado. Idempotente.
export const runMonthlyEvaluation = ({ year, month }) =>
  postJson('/monitoring/run-monthly-eval', { year, month });

// --- Notificaciones ---

export const fetchNotifications = ({
  limit,
  page,
  estado,
  tipo,
  severidad,
  laundryId,
} = {}) =>
  postJson('/monitoring/notifications/filter', {
    limit,
    page,
    estado,
    tipo,
    severidad,
    laundryId,
  });

// Contadores + últimas 10 pendientes. Alimenta el badge de la campana.
export const fetchNotificationsSummary = async () => {
  const response = await fetch(`${API_URL}/monitoring/notifications/summary`);
  return handleResponse(response);
};

// Marca leídas las indicadas (`ids`) o todas las nuevas (`all: true`).
export const markNotificationsRead = ({ ids, all } = {}) =>
  postJson('/monitoring/notifications/mark-read', { ids, all });

// Cierra una notificación como 'resuelta' (default) o 'descartada'.
export const closeNotification = (id, { estado, nota, resueltaPor } = {}) =>
  postJson(`/monitoring/notifications/${id}/resolve`, { estado, nota, resueltaPor });
